import { render } from "./WhatsNew.vue?vue&type=template&id=14ccab6c"
import script from "./WhatsNew.vue?vue&type=script&lang=js"
export * from "./WhatsNew.vue?vue&type=script&lang=js"

import "./WhatsNew.vue?vue&type=style&index=0&id=14ccab6c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__